import { render, staticRenderFns } from "./FAQAccordion.vue?vue&type=template&id=ce006164&scoped=true"
import script from "./FAQAccordion.vue?vue&type=script&lang=js"
export * from "./FAQAccordion.vue?vue&type=script&lang=js"
import style0 from "./FAQAccordion.vue?vue&type=style&index=0&id=ce006164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce006164",
  null
  
)

export default component.exports